import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./SignIn.module.css";
import { singInRequestAdmin } from "./api/index";
import { useAuth } from "../../../context/AuthContext";

export const SignInAdmin = () => {
  const navigate = useNavigate();
  const { onLoginAdmin, googleAuth, isLoading } = useAuth();

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const [error, setError] = useState("");
  const [visible, setVisible] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    if (error) {
      setError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setError("");
      const data = await onLoginAdmin(formData);

      await singInRequestAdmin(formData);
      navigate("/AdminPage");
    } catch (error) {
      console.error("Sign in error:", error);
      setError(error.message || "Մուտքի սխալ: Ստուգեք ձեր տվյալները");
    }
  };

  const handleGoogleSignIn = async () => {
    try {
      setError("");
      console.log("Google sign in clicked");
    } catch (error) {
      console.error("Google sign in error:", error);
      setError("Google մուտքի սխալ");
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.formContainer}>
        <div className={styles.header}>
          <Link to="/" className={styles.logo}>
            viewStruct
          </Link>
          <h1 className={styles.title}>Welcome Back</h1>
          <p className={styles.subtitle}>Sign in to your viewStruct account</p>
        </div>

        {error && <div className={styles.error}>{error}</div>}

        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles.inputGroup}>
            <label htmlFor="username" className={styles.label}>
              username
            </label>
            <input
              type="username"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              className={styles.input}
              placeholder="Enter your username"
              required
              disabled={isLoading}
            />
          </div>

          {/* <div className={styles.inputGroup}>
            <label htmlFor="password" className={styles.label}>
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className={styles.input}
              placeholder="Enter your password"
              required
              disabled={isLoading}
            />
          </div> */}

          <div className={styles.wrapper}>
            <input
              id="password"
              name="password"
              type={visible ? "text" : "password"}
              placeholder="Enter password"
              className={styles.input}
              value={formData.password}
              onChange={handleChange}
              required
              disabled={isLoading}
            />
            <button
              type="button"
              className={styles.eyeBtn}
              onClick={() => setVisible(!visible)}
              aria-label={visible ? "Hide password" : "Show password"}
            >
              {visible ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className={styles.eyeIcon}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M1.5 12s4.5-7.5 10.5-7.5S22.5 12 22.5 12s-4.5 7.5-10.5 7.5S1.5 12 1.5 12z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className={styles.eyeIcon}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M17.94 17.94A10.97 10.97 0 0 1 12 19.5C6 19.5 1.5 12 1.5 12a21.3 21.3 0 0 1 5.04-5.94M9.9 9.9A3 3 0 0 1 14.1 14.1M3 3l18 18" />
                </svg>
              )}
            </button>
          </div>

          {/* <div className={styles.options}>
            <label className={styles.checkbox}>
              <input type="checkbox" disabled={isLoading} />
              <span className={styles.checkmark}></span>
              Remember me
            </label>
            <a href="#" className={styles.forgotPassword}>
              Forgot password?
            </a>
          </div> */}

          <button
            type="submit"
            className={styles.submitBtn}
            disabled={isLoading}
          >
            {isLoading ? "Signing In..." : "Sign In"}
          </button>
        </form>

        {/* <div className={styles.divider}>
          <span>or</span>
        </div>

        <div className={styles.socialButtons}>
          <button
            className={styles.socialBtn}
            onClick={handleGoogleSignIn}
            disabled={isLoading}
            type="button"
          >
            <span>Continue with Google</span>
          </button>
          <button
            className={styles.socialBtn}
            disabled={isLoading}
            type="button"
          >
            <span>Continue with Microsoft</span>
          </button>
        </div>

        <p className={styles.signupPrompt}>
          Don't have an account?{" "}
          <Link to="/signup" className={styles.signupLink}>
            Sign up
          </Link>
        </p> */}
      </div>

      <div className={styles.backgroundDecoration}>
        <div className={styles.shape1}></div>
        <div className={styles.shape2}></div>
        <div className={styles.shape3}></div>
      </div>
    </div>
  );
};
